import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import React, { useState } from 'react';
import { SchemaSelectionComponent } from 'apps/sigma2-ui/src/data-wizard/lib/SchemaSelectionComponent';
import { SchemaSelectionComponentItem } from 'apps/sigma2-ui/src/data-wizard/lib/SchemaSelectionComponent';
import { capitalize } from 'lodash';

export const AddSchemaSelectionComponent = <T,>({
  possibleValues,
  addEntry,
  entryType,
  label,
}: {
  label?: string;
  possibleValues: SchemaSelectionComponentItem<T>[];
  addEntry: (entry: T) => void;
  entryType: string;
}) => {
  const [selectedValueKey, setSelectedValueKey] = useState<string | null>(null);
  const selectedValue = possibleValues.find(
    (value) => value.optionKey === selectedValueKey,
  );
  const [showAddComponent, setShowAddComponent] = useState(false);
  return (
    <div>
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            setShowAddComponent(true);
          },
        }}
        text="Add"
      />
      {showAddComponent && (
        <div>
          <SchemaSelectionComponent
            label={label}
            possibleValues={possibleValues}
            selectedValueKey={selectedValueKey}
            setSelectedValue={(key) => {
              setSelectedValueKey(key);
            }}
          />
          <Button
            behavior={{
              type: 'onClick',
              onClick: () => {
                if (!selectedValue) {
                  return;
                }
                addEntry(selectedValue.optionValue);
                setShowAddComponent(false);
              },
            }}
            text={`Add ${capitalize(entryType)}`}
          />
        </div>
      )}
    </div>
  );
};
